import React, { useState } from "react";
import { ChevronLeft, ChevronRight, Minus, Plus } from "lucide-react";
import { FaRegHeart } from "react-icons/fa";
import { IoHeartSharp } from "react-icons/io5";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "src/components/ui/accordion";
import Navbar from "src/components/Navbar";
import { addcartimg } from "src/assets/images";
import SimilarProducts from "src/components/ProductCategories/SimilarProducts";
import Footer from "src/components/Footer";
import { useParams } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import { AddWishlist, getItemWishlistStatus, getProductDetails, getWishlist, UpdateWishlist } from "src/api";
import { renderErrorMessage, renderSuccessMessage } from "src/assets/functions";
import Modal from "src/components/modal/Modal";
import CartModal from "src/components/modal/CartModal";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { renderCurrency } from "src/components/renderCurrency";


const Cart = () => {
    const { conversionRates } = useProtectedRoutesContext()
    const [isAddQueryModalOpen, setIsAddQueryModalOpen] = useState(false);


    const product = {
        title: "Stylish Fabric",
        price: "₦49.99",
        images: [
            addcartimg,
            addcartimg,
            "/images/product3.jpg",
        ],
        variants: ["Small", "Medium", "Large"],
        colors: ["#FF0000", "#0000FF", "#008000", "#000000"] // Red, Blue, Green, Black
    };


    const { id } = useParams();
    const { data: productDetails } = useQuery({
        queryKey: ["getProductDetails ", id],
        queryFn: () => getProductDetails(id),
    });



    const { user } = useProtectedRoutesContext();
    const isUserLoggedIn = !!user;

    const {
        data: wishliststatus = false, // default to false if undefined
        isLoading: isWishlistLoading,
        refetch,
    } = useQuery({
        queryKey: ["getItemWishlistStatus", id],
        queryFn: () => getItemWishlistStatus(id),
        enabled: isUserLoggedIn && !!id,
    });




    const [currentImageIndex, setCurrentImageIndex] = useState(0);
    const [quantity, setQuantity] = useState(1);
    // const [selectedVariant, setSelectedVariant] = useState(product.variants[0]);
    const [selectedColor, setSelectedColor] = useState(product.colors[0]);

    const nextImage = () => {
        setCurrentImageIndex((prev) => (prev + 1) % productDetails?.data?.itemImages?.length || 0);
    };

    const prevImage = () => {
        setCurrentImageIndex((prev) => (prev - 1 + productDetails?.data?.itemImages?.length || 0) % productDetails?.data?.itemImages?.length || 0);
    };


    const { mutate: addToWishlist, isLoading: isAdding } = useMutation(AddWishlist, {
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
            refetch();
        },
        onError: (error) => renderErrorMessage(error.message),
    });

    // const { data: wishlist } = useQuery({
    //     queryKey: ["getWishlist"],
    //     queryFn: getWishlist
    // });

    const { mutate: updateWishlist, isLoading: isUpdating } = useMutation(UpdateWishlist, {
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
            refetch();
        },
        onError: (error) => renderErrorMessage(error.message),
    });

    const addToCart = (product) => {
        const user = JSON.parse(localStorage.getItem("user"));

        if (!user) {
            renderErrorMessage("Please log in to add items to your cart.");
            return;
        }

        if (!product) return;

        let cart = JSON.parse(localStorage.getItem("cart")) || [];

        const existingItemIndex = cart.findIndex(item => item.id === product.id);

        if (existingItemIndex !== -1) {
            cart[existingItemIndex].quantity += quantity; // Update quantity
        } else {
            cart.push({ ...product, quantity }); // Add new item
        }

        localStorage.setItem("cart", JSON.stringify(cart));
        renderSuccessMessage("Product Added to Cart");

    };




    // const [quantity, setQuantity] = useState(1);

    const decreaseQuantity = () => {
        setQuantity((prev) => Math.max(1, prev - 1));
    };

    const increaseQuantity = () => {
        setQuantity((prev) => prev + 1);
    };




    return (
        <>
            <Navbar />
            <div>
                <div className="container mx-auto py-10 grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <div className="relative">
                        <img
                            src={
                                productDetails?.data?.itemImages?.[currentImageIndex]?.url ||
                                addcartimg
                            }
                            alt="Product"
                            className="w-full rounded-lg shadow-lg"
                        />
                        {productDetails?.data?.itemImages?.length > 1 && (
                            <>
                                <button
                                    onClick={() =>
                                        setCurrentImageIndex((prev) =>
                                            prev === 0
                                                ? productDetails.data.itemImages.length - 1
                                                : prev - 1
                                        )
                                    }
                                    className="absolute left-4 bottom-4 bg-white p-2 rounded-full shadow"
                                >
                                    <ChevronLeft className="w-5 h-5" />
                                </button>
                                <button
                                    onClick={() =>
                                        setCurrentImageIndex((prev) =>
                                            (prev + 1) % productDetails.data.itemImages.length
                                        )
                                    }
                                    className="absolute right-4 bottom-4 bg-white p-2 rounded-full shadow"
                                >
                                    <ChevronRight className="w-5 h-5" />
                                </button>
                            </>
                        )}
                    </div>

                    <div className="space-y-4">
                        <div className="flex justify-between items-center">
                            <h1 className="text-2xl font-bold">{productDetails?.data?.design_number}</h1>
                            <div>
                                {isUserLoggedIn && !isWishlistLoading && (
                                    wishliststatus?.data ? (
                                        <IoHeartSharp
                                            className="w-6 h-6 text-blue-500 cursor-pointer"
                                            onClick={() => updateWishlist({ itemId: productDetails?.data?.id })}
                                        />
                                    ) : (
                                        <FaRegHeart
                                            className="w-6 h-6 text-blue-500 cursor-pointer"
                                            onClick={() => addToWishlist(productDetails?.data?.id)}
                                        />
                                    )
                                )}
                            </div>
                        </div>
                        <p className="text-lg text-gray-600">{renderCurrency(productDetails?.data?.grade?.price * conversionRates[productDetails?.data?.materialId])}</p>
                        <div className="flex items-center space-x-3 mt-[70px]">
                            {productDetails?.data?.colors.map((color, index) => (
                                <button
                                    key={index}
                                    className={`w-8 h-8 rounded-full border-2 ${selectedColor === color ? 'border-black' : 'border-gray-300'}`}
                                    style={{ backgroundColor: color }}
                                    onClick={() => setSelectedColor(color)}
                                ></button>
                            ))}
                        </div>
                        <div className="flex items-center rounded-md overflow-hidden w-[120px] mt-[70px]">
                            <button
                                className="px-3 py-2 hover:bg-gray-200"
                                onClick={decreaseQuantity}
                            >
                                <Minus className="w-4 h-4" />
                            </button>
                            <input
                                type="number"
                                value={quantity}
                                min="1"
                                className="w-full text-center text-lg font-medium border-x border-gray-300"
                                onChange={(e) => {
                                    const value = parseInt(e.target.value, 10);
                                    if (!isNaN(value) && value > 0) {
                                        setQuantity(value);
                                    }
                                    // console.log("Updated Quantity:", value);
                                }}
                            />
                            <button
                                className="px-3 py-2 hover:bg-gray-200"
                                onClick={increaseQuantity}
                            >
                                <Plus className="w-4 h-4" />
                            </button>
                        </div>
                        <div className="proceed-to-check">
                            <button
                                className="w-full mt-[20px] text-white bg-blue-600 px-4 py-2 rounded-md"
                                onClick={() => addToCart(productDetails?.data)}
                                disabled={!isUserLoggedIn}
                            >
                                Add to Cart
                            </button>

                            {!isUserLoggedIn && (
                                <button
                                    className="w-full mt-2 text-blue-600 border border-blue-600 px-4 py-2 rounded-md"
                                    onClick={() => window.location.href = "/login"} // Change to your login path
                                >
                                    Login to Add to Cart
                                </button>
                            )}
                        </div>

                        <div className="view-cart-a-tag">
                            <div onClick={() => {
                                setIsAddQueryModalOpen(true);
                            }}>View Cart</div>
                        </div>
                        {/* <div className="mt-[100px]">
                            <Accordion type="single" collapsible>
                                <AccordionItem value="details">
                                    <AccordionTrigger>Product Details</AccordionTrigger>
                                    <AccordionContent>
                                        This is a premium fabric that offers comfort, style, and durability. Perfect for all occasions.
                                    </AccordionContent>
                                </AccordionItem>
                                <AccordionItem value="shipping">
                                    <AccordionTrigger>Shipping & Returns</AccordionTrigger>
                                    <AccordionContent>
                                        Free shipping on orders over $100. 30-day return policy.
                                    </AccordionContent>
                                </AccordionItem>
                                <AccordionItem value="bundle">
                                    <AccordionTrigger>Bundle Length Guide</AccordionTrigger>
                                    <AccordionContent>
                                        Free shipping on orders over $100. 30-day return policy.
                                    </AccordionContent>
                                </AccordionItem>
                                <AccordionItem value="care">
                                    <AccordionTrigger>Care Instruction</AccordionTrigger>
                                    <AccordionContent>
                                        Free shipping on orders over $100. 30-day return policy.
                                    </AccordionContent>
                                </AccordionItem>
                            </Accordion>
                        </div> */}
                    </div>

                </div>
                <div className="container">
                    <h1 className="consider-header mb-[20px] mt-[70px] also-consider-header">Also Consider</h1>
                    <SimilarProducts />
                </div>
                <Footer />

                <Modal isOpen={isAddQueryModalOpen} setIsOpen={setIsAddQueryModalOpen} title="Item Added to your cart" size="sm">
                    <CartModal setIsOpen={setIsAddQueryModalOpen} />
                </Modal>

            </div>
        </>
    );
};

export default Cart;
